import { Check, Close, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import {
  CancellationUnderage,
  UnderageForm,
} from 'cancellations/view-models/cancellation-underage';
import { memo, useMemo } from 'react';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import UnderageFormComponentMemo from './form';

interface UnderageAccordionProps {
  expanded: boolean;
  toggle: () => void;
  disabled?: boolean;
}

const UnderageAccordionComponent = ({
  expanded,
  toggle,
  disabled,
}: UnderageAccordionProps): React.ReactElement => {
  const formContext = useFormikContext<CancellationUnderage>();

  const errors: FormikErrors<UnderageForm> | undefined = formContext.errors
    ?.underageForm as FormikErrors<UnderageForm>;
  const touched: FormikTouched<UnderageForm> | undefined = formContext.touched
    ?.underageForm as unknown as FormikTouched<UnderageForm>;

  const handleFormFieldChange = useEventCallback(
    (key: keyof UnderageForm, value: UnderageForm[keyof UnderageForm]) => {
      const newForm = {
        ...(formContext.values.underageForm || {}),
        [key]: value,
      };
      formContext.setFieldValue('underageForm', newForm);
    }
  );

  const error = useMemo(() => {
    return !!errors;
  }, [errors]);

  return (
    <Accordion expanded={expanded} onChange={toggle}>
      <AccordionSummary
        aria-controls="panel-death-data-content"
        id="panel-death-data-content"
        expandIcon={<ExpandMore />}
      >
        {error ? <Close color="error" /> : <Check color="success" />}
        <Typography>Cancellazione Minore</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <UnderageFormComponentMemo
          errors={errors}
          touched={touched}
          values={formContext.values.underageForm}
          handleFormFieldChange={handleFormFieldChange}
          disabled={disabled}
        />
      </AccordionDetails>
    </Accordion>
  );
};

UnderageAccordionComponent.displayName = 'Death data accordion component';

const UnderageAccordion = memo(UnderageAccordionComponent);

export default UnderageAccordion;
